import React, { useMemo } from 'react';
import Income from '../Settings_Profile/income/Income'
import Billing from '../Settings_Profile/BillingHistory/BillingHistory'
import Referrals from '../Settings_Profile/Referrals'
import Insights from '../Settings_Profile/InfluencerAnalytics'
import Customers from '../Influencer/Customers/Customers'
import Coupons from '../Settings_Profile/Coupons';
import CreatorBilling from '../Settings_Profile/CreatorBilling';
import CreatorProfile from '../Settings_Profile/Profile/CreatorProfile';
import MoreMenuItems from '../Settings_Profile/Profile/MoreMenuItems';
import PlatformBranding from './Branding/PlatformBranding';
import ExampleCreators from './ExampleCreators';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import theme from '../../theme';
import { useNavigate, useSearchParams } from 'react-router-dom';
import DesktopHeaderCreator from '../common/DesktopHeaderCreator';

const PagePortal = ({ launchHelp, windowWidth, ...props }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const navigate = useNavigate();
  const [searchParams] = useSearchParams()
  const current_page_view = searchParams.get("page");


  const page_view = useMemo(() => {
    switch (current_page_view) {
      case 'home':
        return 'dashboard';
      case 'platform':
        return 'dashboard'
      // return <MyPlatform {...props} />;
      case 'settings':
        return <CreatorProfile {...props} />;
      case 'branding':
        return <PlatformBranding {...props} />;
      case 'examples':
        return <ExampleCreators {...props} />;
      case 'payouts':
        return <Income {...props} />;
      case 'billing':
        return <Billing {...props} />;
      case 'referrals':
        return <Referrals {...props} />;
      case 'promo_codes':
        return <Coupons {...props} />;
      case 'creatorbilling':
        return <CreatorBilling {...props} />;
      case 'insights':
        return <Insights {...props} />;
      case 'customers':
        return <Customers {...props} />;
      case 'more':
        return <MoreMenuItems launchHelp={launchHelp} {...props} />;
      default:
        return 'dashboard' // fall back state
    }
  }, [current_page_view, props]);

  // Sync current_page_view with URL param
  // React.useEffect(() => {
  //   if (page && page !== current_page_view) {
  //     dispatch(setcurrent_page_view(page));
  //   }
  // }, [page, current_page_view, dispatch]);

  return (
    <Grid item xs={12} md={12} lg={10} sx={{ boxSizing: 'border-box', }}>
      <DesktopHeaderCreator
        my_platform_page={props.my_platform_page}
        selected_tab={props.selected_tab}
        influencer_username={props.influencer_username}
        setState={props.setState}
      />

{/* <Box 
                                       sx={{ 
                                          display: 'flex', 
                                          flexDirection: 'row', 
                                          alignItems: 'center', 
                                          justifyContent: 'space-between', 
                                          margin: {lg: '40px 40px 0px 40px', xs: '20px 20px 0px 20px'},
                                          border: '1px solid #FCDC9E',
                                          padding: {xs: '10px', lg: '20px'},
                                          borderRadius: '10px',
                                          backgroundColor: '#FFF5EB',
                                          fontFamily: 'var(--font-family)',
                                       }}
                                    >
                                       <Typography sx={{ color: '#222222', fontSize: '16px', fontWeight: '500', textAlign: 'left', margin: '0px auto', display: 'flex', alignItems: 'center' }}>
                                          <TbAlertTriangle style={{ color: '#ED9B3C', fontSize: '20px', margin: 'auto 10px auto 0px' }}/> Your platform isn't live yet. To start earning, renew your subscription now {' '}
                                          <Typography component="span" onClick={() => {}} sx={{ color: 'var(--brand-color)', cursor: 'pointer', marginLeft: '5px', fontWeight: '500' }}>here</Typography>.
                                       </Typography>
                                    </Box> */}
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding: isMobile ? '20px' : '40px 40px' }}>
        {page_view}
      </Box>
    </Grid>
  )
}

export default PagePortal;